import { FileLabel } from "shared/types/file";
import { API_URL } from "constants/index";
import { fetchWithAuth } from "shared/api/fetch-with-auth";
import { BuildingDTO } from "shared/types/building";

export const calculateBuildingOwnershipDotValues = async (building: BuildingDTO, session: any) => {
    let dotValues: any = {
        red: { count: 0, labels: [] },
        orange: { count: 0, labels: [] },
        green: { count: 0, labels: [] },
        transparent: { count: 0, labels: [] },
    };

    try {
        const queryParams = new URLSearchParams();
        if (building?.id) {
            queryParams.append('buildingId', building.id);
        }

        const labels = [
            FileLabel.AttestAankoop,
            FileLabel.Basisakte,
            FileLabel.Biedbrief,
            FileLabel.Eigendomsakte,
            FileLabel.LOI,
            FileLabel.OnderhandseOvereenkomst,
            FileLabel.ReglementMedeEigendom,
            FileLabel.SPA,
        ];
        queryParams.append('labels', labels.join(','));

        const response = await fetchWithAuth(
            `${API_URL}/file/get-file-logs?${queryParams.toString()}`,
            { method: 'GET' },
            session
        );
        const fileLogs = await response.json();
        
        // Create a map to track which document types we've found
        const documentTypes = new Map();
        let hasOwnershipDocument = false;
        
        // Check for ownership documents
        fileLogs.forEach((log: any) => {
            const label = log.label;
            
            if (label.includes(FileLabel.Eigendomsakte) && !documentTypes.has(FileLabel.Eigendomsakte)) {
                dotValues.green.count++;
                dotValues.green.labels.push("Eigendomsakte aanwezig");
                documentTypes.set(FileLabel.Eigendomsakte, true);
                hasOwnershipDocument = true;
            }
            
            if (label.includes(FileLabel.AttestAankoop) && !documentTypes.has(FileLabel.AttestAankoop)) {
                dotValues.green.count++;
                dotValues.green.labels.push("Attest van aankoop aanwezig");
                documentTypes.set(FileLabel.AttestAankoop, true);
                hasOwnershipDocument = true;
            }
            
            if (label.includes(FileLabel.SPA) && !documentTypes.has(FileLabel.SPA)) {
                dotValues.green.count++;
                dotValues.green.labels.push("SPA aanwezig");
                documentTypes.set(FileLabel.SPA, true);
                hasOwnershipDocument = true;
            }
         
            if (label.includes(FileLabel.Basisakte) && !documentTypes.has(FileLabel.Basisakte)) {
                dotValues.green.count++;
                dotValues.green.labels.push("Basisakte aanwezig");
                documentTypes.set(FileLabel.Basisakte, true);
            }

            if (label.includes(FileLabel.Biedbrief) && !documentTypes.has(FileLabel.Biedbrief)) {
                dotValues.green.count++;
                dotValues.green.labels.push("Biedbrief aanwezig");
                documentTypes.set(FileLabel.Biedbrief, true);
            }

            if (label.includes(FileLabel.LOI) && !documentTypes.has(FileLabel.LOI)) {
                dotValues.green.count++;
                dotValues.green.labels.push("LOI aanwezig");
                documentTypes.set(FileLabel.LOI, true);
            }

            if (label.includes(FileLabel.OnderhandseOvereenkomst) && !documentTypes.has(FileLabel.OnderhandseOvereenkomst)) {
                dotValues.green.count++;
                dotValues.green.labels.push("Onderhandse overeenkomst aanwezig");
                documentTypes.set(FileLabel.OnderhandseOvereenkomst, true);
            }

            if (label.includes(FileLabel.ReglementMedeEigendom) && !documentTypes.has(FileLabel.ReglementMedeEigendom)) {
                dotValues.green.count++;
                dotValues.green.labels.push("Reglement mede-eigendom aanwezig");
                documentTypes.set(FileLabel.ReglementMedeEigendom, true);
            }

            if (label.includes(FileLabel.SPA) && !documentTypes.has(FileLabel.SPA)) {
                dotValues.green.count++;
                dotValues.green.labels.push("SPA aanwezig");
                documentTypes.set(FileLabel.SPA, true);
                hasOwnershipDocument = true;
            }
        });
        
        // If no ownership document is found
        if (!hasOwnershipDocument) {
            dotValues.transparent.count++;
            dotValues.transparent.labels.push("Geen attest van aankoop, SPA, of eigendomsakte aanwezig");
        }

        // Easements indicator and count
        const easements = (building as any)?.buildingOwnershipInfo?.easements || [];
        const easementCount = Array.isArray(easements) ? easements.length : 0;
        if (easementCount > 0) {
            // Mark as attention item (orange) and show count in labels
            dotValues.orange.count++;
            dotValues.orange.labels.push(`Erfdienstbaarheden aanwezig (${easementCount})`);
        }
        
    } catch (error) {
        console.error('Error fetching ownership document logs:', error);
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Fout bij ophalen eigendomsdocumenten");
    }

    return dotValues;
};
